import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
import { servicesData } from '../data';

const Services = () => {
  const [ref, isVisible] = useScrollAnimation();
  const [activeService, setActiveService] = useState(null);
  const services = servicesData || [];

  return (
    <section className="section-padding bg-gray-50" ref={ref}>
      <div className="container-custom">
        <div className="text-center mb-12">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={isVisible ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.6 }}
          >
            <span className="section-badge">What We Offer</span>
            <h2 className="heading-primary mt-4">
              Comprehensive <span className="text-gradient">Solutions</span>
            </h2>
            <p className="text-gray-600 max-w-2xl mx-auto mt-4">
              Combining engineering expertise, skilled manpower, and modern technology 
              to deliver projects on time—every time.
            </p>
          </motion.div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service, index) => (
            <motion.div
              key={service.id || index}
              initial={{ opacity: 0, y: 30 }}
              animate={isVisible ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="bg-white rounded-2xl overflow-hidden shadow-soft card-hover border border-gray-100"
            >
              {/* Service Image */}
              <div className="h-48 overflow-hidden">
                <img 
                  src={service.image || 'https://images.unsplash.com/photo-1504917595217-d4dc5ebe6122?w=400&q=80'} 
                  alt={service.title}
                  className="w-full h-full object-cover transition-transform duration-500 hover:scale-110"
                />
              </div>
              
              <div className="p-6">
                <div className="w-14 h-14 bg-primary/10 rounded-xl flex items-center justify-center mb-4">
                  <i className={`${service.icon || 'uil uil-cog'} text-2xl text-primary`}></i>
                </div>
                <h3 className="text-xl font-bold text-secondary font-oswald mb-2">
                  {service.title || 'Service'}
                </h3>
                <p className="text-gray-600 text-sm mb-4">
                  {service.description || 'Professional service delivered with excellence.'}
                </p>
                {service.features && service.features.length > 0 && (
                  <>
                    <button
                      onClick={() => setActiveService(activeService === service.id ? null : service.id)}
                      className="text-primary font-medium hover:text-primary-dark transition-colors text-sm flex items-center"
                    >
                      {activeService === service.id ? 'Hide Details' : 'View Details'}
                      <i className={`uil uil-angle-${activeService === service.id ? 'up' : 'down'} ml-1`}></i>
                    </button>
                    {activeService === service.id && (
                      <motion.div
                        initial={{ opacity: 0, height: 0 }}
                        animate={{ opacity: 1, height: 'auto' }}
                        transition={{ duration: 0.3 }}
                        className="mt-4 pt-4 border-t border-gray-100"
                      >
                        <ul className="space-y-2">
                          {service.features.map((feature, idx) => (
                            <li key={idx} className="flex items-start text-sm text-gray-600">
                              <i className="uil uil-check-circle text-primary mr-2 mt-0.5"></i>
                              {feature}
                            </li>
                          ))}
                        </ul>
                      </motion.div>
                    )}
                  </>
                )}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;